import { DashboardState, ESdChangeReason, IActionDefinitionDto } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { ActionPicker } from "../properties-panel/action-picker";

export interface IScheduledJobsPropertiesState {
  isSubmitButtonLoading: boolean;
}

export interface IScheduledJobsPropertiesProps {}

class ScheduledJobsProperties extends PureSdComponent<
  IScheduledJobsPropertiesProps & IWithSDProps & IWithContextProp,
  IScheduledJobsPropertiesState
> {
  constructor(props: IScheduledJobsPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      isSubmitButtonLoading: false
    };
  }

  getActions = (): IActionDefinitionDto[] => {
    let actionList: IActionDefinitionDto[] = [];
    actionList = _.cloneDeep(this.props.sd.actionDefinitions);
    return actionList;
  };

  render() {
    const selectedScheduledJob = this.props.sd.getSelectedSj();
    // No job selected means no properties to show. The panel's shell is already gated on
    // `selectedSjId`, so this is the belt to that brace rather than a state anyone sees.
    if (!selectedScheduledJob) return null;

    return (
      <div
        style={{
          fontSize: "11px",
          padding: "5px"
        }}
        className="row kuika_topPanel btn-group-vertical"
      >
        {this.props.sd.dashboardState === DashboardState.scheduledJobs && <ActionPicker />}
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.UpdateAuth) {
      return true;
    }
    return false;
  };
}

const scheduledJobsProperties = withContext<IScheduledJobsPropertiesProps>(
  withSD<IScheduledJobsPropertiesProps>(ScheduledJobsProperties)
);
export { scheduledJobsProperties as ScheduledJobsProperties };
